import { PipeTransform, Pipe } from "@angular/core";
import { DecimalPipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: 'tableValue',
    pure: false
  })
export class TableValuePipe implements PipeTransform {
    constructor(private translationService: TranslateService) {}

    transform(value: number, pattern: string = "1.0-2") {
        return value === -1 ? "N/A" : new DecimalPipe(this.translationService.currentLang).transform(value, pattern);
    }
}